interface ArtechDataWsMessage {
  event: 'artech-usb-data'
  /** This will be the caller's phone number (`0912345678`) */
  data: string
}
export function isArtechDataWsMessage(data: unknown): data is ArtechDataWsMessage {
  const temp = data as ArtechDataWsMessage
  return temp.event === 'artech-usb-data' && typeof temp.data === 'string'
}
